import React, { useLayoutEffect, useReducer, createContext } from 'react'

const BreakpointsContext = createContext()

const MEDIA_QUERIES = {
  SM: '(min-width: 640px)',
  MD: '(min-width: 768px)',
  LG: '(min-width: 1024px)',
  XL: '(min-width: 1280px)',
  XL2: '(min-width: 1536px)',
}

const initialState = {
  sm: false,
  md: false,
  lg: false,
  xl: false,
  xl2: false,
}

function reducer(state, action) {
  switch (action.type) {
    case MEDIA_QUERIES.SM:
      return {
        ...state,
        sm: action.payload,
      }
    case MEDIA_QUERIES.MD:
      return {
        ...state,
        md: action.payload,
      }
    case MEDIA_QUERIES.LG:
      return {
        ...state,
        lg: action.payload,
      }
    case MEDIA_QUERIES.XL:
      return {
        ...state,
        xl: action.payload,
      }
    case MEDIA_QUERIES.XL2:
      return {
        ...state,
        xl2: action.payload,
      }
    default:
      throw new Error()
  }
}

const addEventListener = (target, listener) => {
  if (target.addEventListener) {
    target.addEventListener('change', listener)
  } else {
    target.addListener(listener)
  }
}

const removeEventListener = (target, listener) => {
  if (target.removeEventListener) {
    target.removeEventListener('change', listener)
  } else {
    target.removeListener(listener)
  }
}

const BreakpointsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useLayoutEffect(() => {
    const sm = window.matchMedia(MEDIA_QUERIES.SM)
    const md = window.matchMedia(MEDIA_QUERIES.MD)
    const lg = window.matchMedia(MEDIA_QUERIES.LG)
    const xl = window.matchMedia(MEDIA_QUERIES.XL)
    const xl2 = window.matchMedia(MEDIA_QUERIES.XL2)

    const listener = e => dispatch({ type: e.media, payload: e.matches })

    listener(sm)
    listener(md)
    listener(lg)
    listener(xl)
    listener(xl2)

    addEventListener(sm, listener)
    addEventListener(md, listener)
    addEventListener(lg, listener)
    addEventListener(xl, listener)
    addEventListener(xl2, listener)

    return () => {
      removeEventListener(sm, listener)
      removeEventListener(md, listener)
      removeEventListener(lg, listener)
      removeEventListener(xl, listener)
      removeEventListener(xl2, listener)
    }
  }, [])

  return <BreakpointsContext.Provider value={state}>{children}</BreakpointsContext.Provider>
}

export { BreakpointsProvider, BreakpointsContext }
